import { memo } from 'react'

import { colors, SxProps, Theme, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ThemeTypes } from 'stores/settings'

const sharedBoxStyles: SxProps<Theme> = {
  minHeight: 50,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexGrow: 1,
  borderRadius: 1,
  p: 1,
}

type AdsNotShownProps = {
  number: number
  type: 'before' | 'after'
}

const AdsNotShownRaw = ({ number, type }: AdsNotShownProps) => {
  const { t } = useTranslation(['common', 'domain'])

  const color = colors.red

  return (
    <Typography
      sx={{
        backgroundColor: (theme) => color[theme.palette.mode === ThemeTypes.DARK ? 700 : 300],
        color: (theme) => theme.palette.getContrastText(color[theme.palette.mode === ThemeTypes.DARK ? 700 : 300]),
        ...sharedBoxStyles,
      }}
    >
      {t(`domain:Workspace.Event.${type}EventAds`, { count: number })}
    </Typography>
  )
}

export const AdsNotShown = memo(AdsNotShownRaw)
